import firebase from 'firebase/app';
import shortid from 'shortid';
import { FS } from '../constants';
import { Doc, generateToDocFn } from '../types/Document';
import { Submission, SubmissionCount } from '../types/Submission';
import {
  CollectionListener,
  createSingleCollectionListenerStore,
  useCollectionListener
} from './collectionListener';
import { setDoc, store } from './db';

export const submissionsCollection = () => store().collection(FS.submissions);

export const submissionCountsCollection = () =>
  store().collection(FS.submissionCounts);

export const toSubmissionDoc = generateToDocFn<Submission>((d) => {
  if (!d.status) {
    d.status = 'AWAITING_APPROVAL';
  }
  d.acceptedAt = d.acceptedAt || null;
  d.authorName = d.authorName || '';
  return d;
});
export const toSubmissionCountsDoc = generateToDocFn<SubmissionCount>((d) => d);

const getSubmissionListener = createSingleCollectionListenerStore(
  () => new CollectionListener(submissionsCollection(), toSubmissionDoc)
);

const getSubmissionCountsListener = createSingleCollectionListenerStore(
  () =>
    new CollectionListener(submissionCountsCollection(), toSubmissionCountsDoc)
);

export const updateSubmission = (
  submissionId: string,
  submission: Submission
) => {
  return submissionsCollection().doc(submissionId).set(submission);
};

export const deleteSubmission = (submissionId: string) => {
  return submissionsCollection().doc(submissionId).delete();
};

export const createSubmission = (submission: Submission) => {
  const doc: Doc<Submission> = {
    id: shortid(),
    collection: FS.submissions,
    data: {
      ...submission,
      createdAt: firebase.firestore.Timestamp.now()
    }
  };
  return setDoc(doc);
};

export const useSubmissions = () => {
  return useCollectionListener(getSubmissionListener());
};

export const useSubmissionCounts = () => {
  return useCollectionListener(getSubmissionCountsListener());
};
